<template>
  <!--<transition mode="out-in"-->
  <!--enter-active-class="animated zoomInUp"-->
  <!--leave-active-class="animated zoomOutDown">-->
  <div style="width: 100%">

    <!--主图-->
    <div class="mainImg">
      <img src="../assets/softwareShow.jpg" alt="产品展示">
    </div>

    <!--产品展示-->
    <div class="productInfoArea1">
      <div class="totalProduct"  v-for="(value,index) in  productInfoArea1" :id="value.productId">
        <div class="video" v-if="index%2===0">
          <video-player class="vjs-custom-skin"
                        :options="playerOptions[index]"
                        ref="videoPlayer"></video-player>
        </div>
        <div class="textInfo1" v-if="index%2===0">
          <!--产品名字-->
          <span class="productTitle">{{value.productTitle}}</span>
          <!--产品简介-->
          <p class="shortInfo">
            <span style="display: inline-block;width: 50%;text-align: right">下载量</span>：
            <span style="display: inline-block;width: 50%;text-align: left">{{value.downloadCount}}</span>
          </p>
          <p class="shortInfo">
            <span style="display: inline-block;width: 50%;text-align: right">应用版本</span>：
            <span style="display: inline-block;width: 50%;text-align: left">{{value.appVersion}}</span>
          </p>
          <p class="shortInfo">
            <span style="display: inline-block;width: 50%;text-align: right">上架时间</span>：
            <span style="display: inline-block;width: 50%;text-align: left">{{transDate(value.createDate)}}</span>
          </p>
          <p class="contentInfo">{{value.productDescribe}}</p>
          <div class="Download">
            <Button type="success" size="large" style="width: 100px" @click.native="androidDown(value.downloadUrl, value.id, value.downloadCount)">安卓下载</Button>
            <Button type="success" size="large" style="width: 100px; margin-left: 20px" @click.native="getDetails(value.packageName)">应用详情</Button>
          </div>
        </div>
        <div class="textInfo2" v-if="index%2!==0">
          <!--产品名字-->
          <span class="productTitle">{{value.productTitle}}</span>
          <!--产品简介-->
          <span class="shortInfo">下载量：{{value.downloadCount}}</span>
          <span class="shortInfo">应用版本：{{value.appVersion}}</span>
          <span class="shortInfo">上架时间：{{transDate(value.createDate)}}</span>
          <p class="contentInfo">{{value.productDescribe}}</p>
          <div class="Download">
            <Button type="success" size="large" style="width: 100px" @click.native="androidDown(value.downloadUrl, value.id, value.downloadCount)">安卓下载</Button>
            <Button type="success" size="large" style="width: 100px; margin-left: 20px" @click.native="getDetails(value.packageName)">应用详情</Button>
          </div>
        </div>
        <div class="video" v-if="index%2!==0">
          <video-player class="vjs-custom-skin" :options="playerOptions[index]"></video-player>
        </div>
      </div>
    </div>
    <div class="productInfoArea2">
      <div class="productInfoList" v-for="(value) in  productInfoArea2" :id="value.productId">
        <!--产品名字-->
        <img class="listImg" :src="value.appLogo"><br>
        <span class="listInfo">{{value.productTitle}}</span>
        <p class="listContent">{{value.productShortDescribe}}</p>
        <div class="Download">
          <Button type="success" size="large" style="width: 100px" @click.native="androidDown(value.downloadUrl, value.id, value.downloadCount)">安卓下载</Button>
          <Button type="success" size="large" style="width: 100px; margin-left: 10px" @click.native="getDetails(value.packageName)">应用详情</Button>
        </div>
      </div>
    </div>
    <div class="productInfoArea3">
      <span class="area3Title">启明工具类产品</span><br><br><br>
      <div v-for="(value) in  productInfoArea3" :id="value.productId">
        <div class="area3Content">
          <p>{{value.productTitle}}</p>
          <span>{{value.productShortDescribe}}</span>
          <div style="display: flex;">
            <Button type="success" size="large" style="width: 100px;" @click.native="androidDown(value.downloadUrl, value.id, value.downloadCount)">安卓下载</Button>
            <Button type="success" size="large" style="width: 100px; float: right; margin-left: 20px" @click.native="getDetails(value.packageName)">应用详情</Button>
          </div>
        </div>
        <br><br><br>
      </div>
    </div>
    <!--页脚-->
    <div class="footer">
      <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
        <li class="info">Copyright © 2017-2020 All rights reserved 版权所有 © 无障碍科技有限公司</li>
        <li class="info">备案号：鄂ICP备18005954号</li>
      </ul>
    </div>

  </div>
  <!--</transition>-->
</template>

<script>
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  //引入hls.js
  import 'videojs-contrib-hls.js/src/videojs.hlsjs'
  import {formatDate} from "../../utils/format";
  export default {
    name: "productionShow",
    data(){
      return {
        playerOptions:[],
        productInfoArea1:[],//产品列表1
        productInfoArea2:[],//产品列表2
        productInfoArea3:[] //产品列表3
      }
    },
    methods:{
      getDetails(packageName){
          let routeUrl;
          if (packageName){
              routeUrl = this.$router.resolve({
                  path:'/productDetails?packageName=' + packageName
              });
          } else {
              routeUrl = this.$router.resolve({
                  path:'/productionShow'
              });
          }
          window.open(routeUrl.href, '_blank');
      },
      transDate(time){
         return formatDate(new Date(time), 'yyyy-MM-dd')
      },
      androidDown(url, id, count){
        if (url){
            window.open(url);
            count = count + 1;
            this.$http.post('/zm/WMWebsite/updateProductInfo', {'id': id, 'downloadCount': count});
        } else {
            this.$Message.error('抱歉，该产品的下载链接出现了问题');
        }
      },//安卓下载
      iosDown(){
        //TODO ios下载
      },//ios下载
      gotoDetail(){
        let goodid="#"+this.$route.query.goodID;
        if(this.$route.query.goodID!==undefined){
          document.querySelector(goodid).scrollIntoView(true);
        }
      },//从首页点击产品跳转过来的时候，自动跳转到产品的详情位置
      getData(){
          this.productInfoArea1 = [];
          this.productInfoArea2 = [];
          this.productInfoArea3 = [];
        this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(res=>{
          let tempList1 = res.data.content.productInfoArea1;
          let tempList2 = res.data.content.productInfoArea2;
          let tempList3 = res.data.content.productInfoArea3;
          tempList1.map((item) => {
              if (item.active === 1){
                  this.productInfoArea1.push(item);
                  this.playerOptions.push({
                      playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                      autoplay: false, //如果true,浏览器准备好时开始回放。
                      controls: true, //控制条
                      preload: 'auto', //视频预加载
                      muted: false, //默认情况下将会消除任何音频。
                      loop: false, //导致视频一结束就重新开始。
                      language: 'zh-CN',
                      aspectRatio: '9:16', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                      sources: [{
                          type: 'video/mp4',
                          src: item.playerSrc,
                      }],
                      poster: item.posterSrc.split('分割')[0]//你的封面地址
                  })
              }
          });
          tempList2.map((item) => {
              if (item.active === 1) {
                  this.productInfoArea2.push(item);
              }
          });
          tempList3.map((item) => {
              if (item.active === 1) {
                  this.productInfoArea3.push(item);
              }
          });
        })
      }//获取产品列表信息
    },
    watch:{
      'goodsList':function () {
        this.$nextTick(function () {
          this.gotoDetail();
        })
      }
    },
    activated() {
      this.getData();
    }
  }
</script>

<style scoped>
  .mainImg img{
    width: 100%;
    height: 600px;
  }/*主图*/
  .productInfoArea1{
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }
  .totalProduct{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;
  }
  .video{
    display: flex;
    width: 40%;
    height: 640px;
    align-items: center;
    justify-content: center;
  }
  .vjs-custom-skin{
    width: 322px;
    height: 572px;
  }
  .textInfo1{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 60%;
    height: 640px;
    background: rgba(63, 175, 174, 0.4);
    background: -moz-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(63, 175, 174, 0.4)), color-stop(100%,white));
    background: -webkit-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%,white 100%);
    background: -o-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -ms-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: linear-gradient(to left,  rgba(63, 175, 174, 0.4) 0%,white 100%);
  }
  .textInfo2{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 60%;
    height: 640px;
    background: rgba(63, 175, 174, 0.4);
    background: -moz-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -webkit-gradient(linear, right top, left bottom, color-stop(0%,rgba(63, 175, 174, 0.4)), color-stop(100%,white));
    background: -webkit-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%,white 100%);
    background: -o-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -ms-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: linear-gradient(to right,  rgba(63, 175, 174, 0.4) 0%,white 100%);
  }
  .productTitle{
    width: 100%;
    font-weight: bold;
    font-size: 3.0rem;
    color: rgba(63, 175, 174, 1);
  }/*产品的名称*/
  .shortInfo{
    width: 100%;
    font-size: 0.9rem;
    color: rgba(63, 175, 174, 1);
    display: flex;
    justify-content: center;
  }
  .contentInfo{
    overflow: hidden;
    display: inline-block;
    text-align: left;
    width: 60%;
    color: rgba(63, 175, 174, 1);
    text-indent: 48px;
    font-size: 24px;
    margin-top: 24px;
  }
  .productInfoArea2{
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 50px;
    margin-left: 10%;
    margin-right: 10%;
  }
  .productInfoList{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    width: 20%;
    height: 300px;
    margin-right: 30px;
    margin-bottom: 30px;
  }
  .listImg{
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .listInfo{
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: rgba(63, 175, 174, 1);
  }
  .listContent{
    overflow: hidden;
    display: inline-block;
    width: 60%;
    height: 100px;
    text-align: center;
    color: rgba(63, 175, 174, 1);
    font-size: 18px;
    margin-top: 18px;
  }
  .Download {
    margin-top: 3%;
    display: flex;
    text-align: center;
  }/*下载按钮*/
  .qiming-FM{
    /*background-color: #CCCCCC;*/
  }/*启明Fm背景色*/
  .productInfoArea3{
    width: 100%;
    margin-top: 50px;
    display: inline-block;
  }
  .area3Title{
    font-size: 32px;
    font-weight: bolder;
    padding-left: 140px;
  }
  .area3Content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    float: left;
    margin-left: 14%;
    width: 55%;
    font-size: 22px;
  }
  .area3Content p{
    display: inline-block;
    min-width: 150px;
  }
  .area3Content span{
    font-size: 16px;
    color: #acacac;
    line-height: 30px;
    display: inline-block;
    width: 200px;
    height: 30px;
    overflow: hidden;
  }
  .footer{
    background-color: rgba(57, 207, 204, 1);
    text-align: center;
    width: 100%;
    height: 130px;
  }/*页脚*/
  .footer .info{
    color:#fff;
    font-size:0.8rem;
  }/*页脚：里面的内容*/


  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 1022px)
  and (orientation: portrait){
    .mainImg img{
      height: 200px;
    }
    .totalProduct{
      flex-wrap: wrap;
    }
    .textInfo1{
      width: 100%;
      order: 1;
    }
    .textInfo2{
      width: 100%;
      order: 1;
    }
    .video{
      width: 100%;
      order: 2;
    }
    .productInfoList{
      width: 50%;
      margin-left: 25%;
    }
    .productInfoArea2{
      margin-left: 0;
    }
    .productInfoArea3{
      text-align: center;
    }
    .area3Title{
      padding-left: 0;
    }
    .area3Content{
      width: 72%;
    }

  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){
    .mainImg img{
      height: 300px;
    }
  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){
    .mainImg img{
      height: 400px;
    }
  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){
    .mainImg img{
      height: 400px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/productionShow.vue